var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.85658 11.6254C0.495835 11.9861 0.495835 12.571 0.85658 12.9318C1.21732 13.2925 1.80221 13.2925 2.16295 12.9318L0.85658 11.6254ZM12.9906 1.72149C12.9906 1.21132 12.577 0.797743 12.0668 0.797743H3.75314C3.24297 0.797743 2.8294 1.21132 2.8294 1.72149C2.8294 2.23166 3.24297 2.64523 3.75314 2.64523H11.1431V10.0352C11.1431 10.5454 11.5567 10.9589 12.0668 10.9589C12.577 10.9589 12.9906 10.5454 12.9906 10.0352V1.72149ZM2.16295 12.9318L12.72 2.37467L11.4137 1.0683L0.85658 11.6254L2.16295 12.9318Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtn);
export default __webpack_public_path__ + "static/media/arrow_btn.cebc455f26a734bf0bbd223f6f8e1956.svg";
export { ForwardRef as ReactComponent };